<template>
  <div class="content">
    <div class="title">系统设置</div>
    <div class="subTitle">硬件绑定</div>

    <div class="subTitle-switch">
      <el-row >
        <el-col :span="2"><el-switch v-model="value1" @change="submit"></el-switch></el-col>
        <el-col :span="5">是否启用硬件绑定</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { API__code,API_Company} from '../../../api/index.js'
export default {
  data(){
    return{
      value1:true,
      token:'',
      checkCode:'',
    }
  },
  created(){
      this.getCookie();
      var param = {
        id:sessionStorage.getItem('companyuseid'),
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Company.getCompany(param)
        .then((res) => {
          this.value1 = res.data.data.isbinding == 1?true:false
        })
  },
  methods:{
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); 
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1];
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
        }
      }
    },
    submit(){
      var param = {
        id:sessionStorage.getItem('companyuseid'),
        isbinding:this.value1?1:0,
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Company.hardwareBinding(param)
        .then((res) => {
          this.$message.success("修改成功")
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.content{
  width: 100%;
  height: 600px;
  position: relative;
  margin-top: 20px;
  padding: 20px;
  box-sizing: border-box;
}

.title{
  color:#666666;
  font-size: 20px;
}

.subTitle{
  color:#666666;
  font-size: 14px;
  margin-top: 10px;
}

.subTitle-switch{
  color:#666666;
  font-size: 16px;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// system.vue?8b4b4cfa